// Windsurf generated file
import { http, HttpResponse } from 'msw'
import { FeatureFlags } from './feature-flags-api'

/**
 * Mock feature flags for testing and development
 */
export const mockFeatureFlags: FeatureFlags = {
  ENABLE_PARTIAL_MATURITIES: false,
  ENABLE_PROPOSAL_DESCRIPTIONS: true,
  ENABLE_DEV_TOOLS: true,
  ENABLE_PARTIAL_MATURITIES_BY_DOLLAR_AMOUNT: false,
  ENABLE_ISSUER_STATUS: false,
}

/**
 * MSW handlers for feature flags API
 */
export const handlers = [
  http.get('**/api/feature-flags/:featureFlag', ({ params }) => {
    const { featureFlag } = params
    const flags = mockFeatureFlags as unknown as Record<string, boolean>
    const value = flags[featureFlag as string] ?? false
    // API returns a JSON boolean
    return HttpResponse.json(value)
  }),
]
